module.exports = __webpack_public_path__ + "img/cn-bg-powers.f45c020.png";